import angular from 'angular';
import angularUiBootstrap from 'angular-ui-bootstrap';

import tree from '../tree';
import utils from '../utils';

import akamGroup from './group-component';

/**
 * @ngdoc module
 * @name akamai.components.group
 *
 * @requires module:ngModel
 * @description Provides a simple group selector component, based on akam-tree. This component may
 * be used when an application needs to create a domain object for a particular group
 * (and by extension, contract) and would otherwise have no use for groups.
 *
 * @example group.html
 * {% raw %}
 * <akam-group
 *   ng-model="myModel"
 *   ids-scope="'PM_OPEN_AND_READ'"
 *   ng-change="onChangeCallback(item)">
 * </akam-group>
 * {% endraw %}
 */
export default angular.module('akamai.components.group', [
  angularUiBootstrap,
  tree.name,
  utils.name
])
/**
 * @ngdoc directive
 *
 * @name akamGroup
 * @description Creates a group selector control
 * @restrict E
 * @param {Object} ng-model The selected group
 * @param {String} ids-scope the scope that we should use when making the AuthZ request. If the
 * special string "ALL" is provided, then, then the /groups AuthZ call will be made.
 * @param {*} [clearable] If present, the selected item will be clearable.
 * @param {string|TranslateKey} [placeholder] The placeholder text for the selected item field.
 */
  .component('akamGroup', akamGroup);
